import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function RenderViewContainer({ label, children }) {
  const { t } = useTranslation();
  return (
    <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', height: '18px', gap: 15 }}>
      <Typography
        fontSize="16px"
        lineHeight="19px"
        sx={{
          whiteSpace: 'nowrap',
          color: ({ palette }) => palette.text.disabled,
        }}
      >
        {t(label)}
      </Typography>
      {children}
    </div>
  );
}
